// Trims to 2dp whatever scale the wire carries: amount_usd has been serialised
// at more than two decimal places before ("500.0000"), and the column's
// declared scale is not something this file can rely on. Deliberately
// duplicated from marketplace's commerce-state.ts rather than shared (see
// period.ts's header for why). '—' matches shortDate's own missing-value
// fallback in BillingSubscriptions.tsx rather than risking "$NaN".

export function formatUsd(amountUsd: string): string {
  const n = Number(amountUsd);
  return amountUsd !== '' && Number.isFinite(n) ? n.toFixed(2) : '—';
}
